import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { toObjectMap } from "@@/utilities/dictionary";
import { z } from "zod";

const bookableSessionStatusTypes = [
    "FULL",
    "CANCELLED",
    "ACTIVE",
    "CLOSED",
    "DANCING",
] as const;
type BookableSessionStatusType = (typeof bookableSessionStatusTypes)[number];
const bookableSessionStatusType = toObjectMap<BookableSessionStatusType>([
    ...bookableSessionStatusTypes,
]);

const bookableSessionStatusTypeZodSchema: z.ZodSchema<BookableSessionStatusType> =
    z.enum(bookableSessionStatusTypes);

type SessionStatus = {
    _created: IsoAndUnixTimestamp;
    type: BookableSessionStatusType;
};

const createSessionStatus = (params: {
    type: BookableSessionStatusType;
}): SessionStatus => {
    return {
        _created: nowIsoAndUnix(),
        ...params,
    };
};

const sessionStatusZodSchema: z.ZodSchema<SessionStatus> = z.object({
    _created: isoAndUnixZodSchema,
    type: bookableSessionStatusTypeZodSchema,
});

export {
    bookableSessionStatusType,
    bookableSessionStatusTypes,
    createSessionStatus,
    sessionStatusZodSchema,
};
export type { BookableSessionStatusType, SessionStatus };
